import {inject, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LoadingService {
  private readonly zone = inject(NgZone);
  private activeRequests = 0;
  private readonly loadingSubject = new BehaviorSubject(false);

  readonly isLoading$ = this.loadingSubject.asObservable();

  addRequest(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.zone.run(() => this.loadingSubject.next(true));
    }
  }

  removeRequest(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this.zone.run(() => this.loadingSubject.next(false));
    }
  }
}
